import { ApiError } from './api';

const YEKATERINBURG = 'Asia/Yekaterinburg';

export const STABLE_PROBLEM_MESSAGES: Record<string, string> = {
  MALFORMED_REQUEST: 'Запрос сформирован некорректно.',
  VALIDATION_ERROR: 'Проверьте введённые данные.',
  UNAUTHENTICATED: 'Сеанс недействителен. Войдите снова.',
  AUTH_SESSION_REVOKED: 'Сеанс отозван. Войдите снова.',
  REFRESH_TOKEN_INVALID: 'Сеанс недействителен. Войдите снова.',
  REFRESH_TOKEN_REUSED: 'Сеанс отозван. Войдите снова.',
  FORBIDDEN: 'Недостаточно прав для этого действия.',
  CAPABILITY_INVALID: 'Ссылка доступа недействительна.',
  CAPABILITY_EXPIRED: 'Срок действия ссылки доступа истёк.',
  CAPABILITY_REVOKED: 'Ссылка доступа отозвана.',
  CAPABILITY_CLOSED: 'Ссылка доступа закрыта.',
  RESOURCE_NOT_FOUND: 'Запись не найдена.',
  STALE_VERSION: 'Данные были изменены. Состояние обновлено, повторите действие.',
  IDEMPOTENCY_KEY_CONFLICT: 'Повтор того же действия конфликтует с уже выполненным запросом.',
  IDEMPOTENCY_IN_PROGRESS: 'То же действие ещё выполняется. Подождите и повторите позже.',
  INVALID_STATE_TRANSITION: 'Действие недопустимо в текущем состоянии.',
  OPEN_INTEGRATION_EXCEPTION: 'Есть неразрешённое интеграционное исключение.',
  OPEN_SYNC_CONFLICT: 'Есть неразрешённый конфликт синхронизации.',
  SYNC_CONFLICT: 'Обнаружен конфликт синхронизации.',
  INCOMPLETE_CHECKLIST: 'Чек-лист заполнен не полностью.',
  MISSING_REQUIRED_ASSESSMENT: 'Не выставлена обязательная оценка.',
  FAIL_DETAILS_REQUIRED: 'Для отрицательной оценки требуется описание несоответствия.',
  NOT_APPLICABLE_JUSTIFICATION_REQUIRED: 'Для оценки «не применяется» требуется обоснование.',
  NO_SHOW_GRACE_PERIOD_NOT_ELAPSED: 'Льготный период неявки ещё не истёк.',
  SIGNING_NOT_AUTHORIZED: 'Подписание этим пользователем недопустимо.',
  FACSIMILE_NOT_AVAILABLE: 'Факсимиле недоступно.',
  FACSIMILE_NOT_OWNED: 'Факсимиле принадлежит другому пользователю.',
  RESULT_VERSION_MISMATCH: 'Версия результата не совпадает с ожидаемой.',
  DOCUMENT_GENERATION_STATE_INVALID: 'Документ нельзя сформировать в текущем состоянии.',
  EMAIL_DELIVERY_STATE_INVALID: 'Письмо нельзя отправить в текущем состоянии.',
  INTEGRATION_UNAVAILABLE: 'Внешняя интеграция временно недоступна.',
  INTEGRATION_THROTTLED: 'Внешняя интеграция временно ограничила запросы.',
  IMPORT_PUBLISH_BLOCKED: 'Публикация импорта недоступна в текущем состоянии.',
  IMPORT_MAPPING_INVALID: 'Сопоставление полей импорта некорректно.',
  PASSWORD_CHANGE_REQUIRED: 'Требуется смена пароля.',
  CONFIGURATION_INCOMPLETE: 'Не завершена необходимая конфигурация системы.',
  QUALIFICATION_MISSING: 'Отсутствует необходимая квалификация инспектора.',
  INVALID_ACTIVATION_TARGET: 'Выбранная цель активации недопустима.',
};

const CASE_STATUS_LABELS: Record<string, string> = {
  AWAITING_PREFILL: 'Ожидает предзаполнения',
  PREFILL_IN_PROGRESS: 'Предзаполнение в работе',
  PREFILLED: 'Предзаполнение завершено',
  READY_FOR_INSPECTION: 'Готов к осмотру',
  IN_PROGRESS: 'В работе',
  PENDING_SYNC: 'Ожидает синхронизации',
  COMPLETED: 'Завершён',
  APPROVED: 'Допущено',
  REJECTED: 'Не допущено',
  REINSPECTION_REQUIRED: 'Требуется повторный осмотр',
  ARCHIVED: 'В архиве',
  CANCELLED: 'Отменён',
  NO_SHOW: 'Неявка',
  ABORTED: 'Прерван',
};

const BOOKING_STATUS_LABELS: Record<string, string> = {
  BOOKED: 'Забронирован',
  RESCHEDULED: 'Перенесён',
  CANCELLED: 'Отменён',
  NO_SHOW: 'Неявка',
};

const CHECKLIST_STATUS_LABELS: Record<string, string> = {
  OPEN: 'Открыт',
  COMPLETE: 'Завершён',
  FROZEN: 'Зафиксирован',
};

const DOCUMENT_STATUS_LABELS: Record<string, string> = {
  GENERATION_QUEUED: 'В очереди на формирование',
  GENERATED: 'Готов',
  GENERATION_ERROR: 'Ошибка формирования',
};

const EMAIL_STATUS_LABELS: Record<string, string> = {
  SEND_QUEUED: 'В очереди',
  SENT: 'Отправлено',
  SEND_ERROR: 'Ошибка отправки',
};

const USER_STATUS_LABELS: Record<string, string> = {
  ACTIVE: 'Активен',
  DISABLED: 'Отключён',
};

const ROLE_LABELS: Record<string, string> = {
  SYSTEM_ADMIN: 'Системный администратор',
  INSPECTOR: 'Инспектор',
  INSPECTOR_PS: 'Инспектор ПС',
  INSPECTOR_CHASSIS: 'Инспектор шасси',
  SIGNING_INSPECTOR: 'Подписывающий инспектор',
};

const MASTER_STATUS_LABELS: Record<string, string> = {
  ACTIVE: 'Активен',
  ARCHIVED: 'В архиве',
};

const EMAIL_SCOPE_KIND_LABELS: Record<string, string> = {
  RULE: 'Правило',
  GLOBAL: 'Глобальная политика',
};

const EMAIL_POLICY_STATUS_LABELS: Record<string, string> = {
  ACTIVE: 'Активна',
  INACTIVE: 'Неактивна',
};

const ACTOR_TYPE_LABELS: Record<string, string> = {
  USER: 'Пользователь',
  INSPECTOR: 'Инспектор',
  CONTRACTOR: 'Подрядчик',
  SYSTEM: 'Система',
};

const SUBJECT_TYPE_LABELS: Record<string, string> = {
  USER: 'Пользователь',
  CONTRACTOR_ORGANIZATION_PROFILE: 'Профиль подрядчика',
  VEHICLE_EQUIPMENT_PROFILE: 'Профиль ТС',
  CHECKLIST_TEMPLATE: 'Шаблон',
  TEMPLATE_VERSION: 'Версия шаблона',
  TEMPLATE_IMPORT_PROFILE: 'Профиль импорта',
  TEMPLATE_IMPORT_RUN: 'Результат импорта',
  INSPECTION_CASE: 'Осмотр',
  EMAIL_RECIPIENT_POLICY: 'Политика email',
  RUBITIME_BUSINESS_CONFIG: 'Конфигурация Rubitime',
  RubitimeBusinessConfig: 'Конфигурация Rubitime',
  REFERENCE_DATA_DATASET: 'Справочник',
  FACSIMILE: 'Факсимиле',
  QUALIFICATION: 'Квалификация',
  ASSIGNMENT: 'Назначение',
};

const DUPLICATE_FIELD_LABELS: Record<string, string> = {
  legal_name: 'Юридическое наименование',
  inn: 'ИНН',
  aliases: 'Псевдонимы',
  registration_plate: 'Госномер',
  vin: 'VIN',
  alternative_identifier: 'Альтернативный идентификатор',
};

const EVENT_TYPE_LABELS: Record<string, string> = {
  INSPECTION_CASE_STARTED: 'Осмотр начат',
  INSPECTION_CASE_FIELD_CORRECTED: 'Поле осмотра исправлено',
  INSPECTION_DECISION_CREATED: 'Зафиксировано решение',
  CHECKLIST_FACTUAL_FINALIZED: 'Чек-лист зафиксирован',
  INSPECTION_RESULT_VERSION_CREATED: 'Создана редакция результата',
  INSPECTION_CASE_SIGNED: 'Осмотр подписан',
  DOCUMENT_ARTIFACT_GENERATED: 'Документ сформирован',
  DOCUMENT_ARTIFACT_GENERATION_FAILED: 'Ошибка формирования документа',
  DOCUMENT_ARTIFACT_GENERATION_REQUEUED: 'Повторное формирование документа',
  EMAIL_DELIVERY_QUEUED: 'Письмо поставлено в очередь',
  EMAIL_DELIVERY_SENT: 'Письмо отправлено',
  EMAIL_DELIVERY_SEND_FAILED: 'Ошибка отправки письма',
  EMAIL_DELIVERY_RETRY_REQUESTED: 'Повторная отправка письма',
  EMAIL_DISPATCH_CONFIGURATION_INCOMPLETE: 'Не завершена конфигурация отправки',
  CHECKLIST_INSPECTOR_ASSIGNMENT_CHANGED: 'Изменено назначение инспектора',
  PROTECTED_LINK_ISSUED: 'Выдана ссылка подрядчику',
  PROTECTED_LINK_ACCESSED: 'Подрядчик открыл ссылку',
  CONTRACTOR_PREFILL_UPDATED: 'Подрядчик обновил предзаполнение',
  CONTRACTOR_PREFILL_SUBMITTED: 'Подрядчик отправил предзаполнение',
  PROTECTED_LINK_REVOKED: 'Ссылка подрядчику отозвана',
  USER_CREATED: 'Создан пользователь',
  USER_ROLES_REPLACED: 'Изменены роли пользователя',
  USER_STATUS_CHANGED: 'Изменён статус пользователя',
  USER_PASSWORD_RESET_BY_ADMIN: 'Администратор сбросил пароль',
  USER_ONBOARDED_TEMPORARY_PASSWORD: 'Пользователь создан с одноразовым паролем',
  USER_TEMPORARY_PASSWORD_ISSUED: 'Выдан одноразовый пароль',
  USER_PASSWORD_CHANGED: 'Пароль изменён',
  USER_SESSIONS_REVOKED_FOR_PASSWORD: 'Сеансы отозваны после смены пароля',
  FACSIMILE_VERSION_PROVISIONED: 'Загружена версия факсимиле',
  CONTRACTOR_PROFILE_CREATED: 'Создан профиль подрядчика',
  CONTRACTOR_PROFILE_UPDATED: 'Обновлён профиль подрядчика',
  CONTRACTOR_PROFILE_ARCHIVED: 'Профиль подрядчика архивирован',
  VEHICLE_PROFILE_CREATED: 'Создан профиль ТС',
  VEHICLE_PROFILE_UPDATED: 'Обновлён профиль ТС',
  VEHICLE_PROFILE_ARCHIVED: 'Профиль ТС архивирован',
  IMPORT_ARTIFACT_UPLOADED: 'Загружен исходный файл импорта',
  IMPORT_PROFILE_CREATED: 'Создан профиль импорта',
  IMPORT_PROFILE_REVISION_CREATED: 'Создана редакция профиля импорта',
  IMPORT_RUN_CREATED: 'Создан прогон импорта',
  IMPORT_MAPPING_CORRECTED: 'Исправлено сопоставление импорта',
  IMPORT_VALIDATION_COMPLETED: 'Завершена проверка импорта',
  CHECKLIST_TEMPLATE_CREATED: 'Создан шаблон',
  TEMPLATE_VERSION_PUBLISHED: 'Опубликована версия шаблона',
  TEMPLATE_ACTIVE_VERSION_CHANGED: 'Изменена активная версия шаблона',
  INSPECTOR_QUALIFICATION_CHANGED: 'Изменена квалификация инспектора',
  EMAIL_RECIPIENT_POLICY_CHANGED: 'Изменена политика получателей email',
  EMAIL_RECIPIENT_RESOLUTION_PREVIEWED: 'Выполнен предпросмотр получателей email',
  RUBITIME_BUSINESS_CONFIG_CHANGED: 'Изменена бизнес-конфигурация Rubitime',
  REFERENCE_DATA_BUSINESS_CONFIG_CHANGED: 'Изменён справочник',
};

export const KNOWN_AUDIT_EVENT_TYPES = Object.keys(EVENT_TYPE_LABELS).sort();

export function problemMessage(failure: unknown): string {
  if (failure instanceof ApiError) {
    const dependency = failure.problem.errors?.find(
      (row) => row.code === 'ACTIVE_PACKAGE_DEPENDENCY',
    );
    if (dependency !== undefined) {
      const labels =
        typeof dependency.message === 'string' && dependency.message.trim().length > 0
          ? dependency.message.trim()
          : null;
      return labels === null
        ? 'Нельзя переместить чек-лист в «Удалённые»: он входит в текущий активный пакет вида техники. Сначала создайте и активируйте пакет без этого чек-листа.'
        : `Нельзя переместить чек-лист в «Удалённые»: он входит в текущий активный пакет вида техники. Сначала создайте и активируйте пакет без этого чек-листа. Зависимости: ${labels}`;
    }
    const detail = failure.problem.detail;
    if (
      typeof detail === 'string' &&
      detail.trim().length > 0 &&
      detail !== 'The request was rejected by Inspection Core.' &&
      /[А-Яа-яЁё]/.test(detail)
    ) {
      return detail;
    }
    const code = failure.problem.code;
    if (code !== undefined && STABLE_PROBLEM_MESSAGES[code] !== undefined) {
      return STABLE_PROBLEM_MESSAGES[code];
    }
    return 'Ошибка запроса.';
  }
  return 'Не удалось выполнить запрос.';
}

export function problemTechnicalDetail(failure: unknown): string | null {
  if (!(failure instanceof ApiError)) {
    return null;
  }
  const parts: string[] = [];
  if (failure.problem.code !== undefined) {
    parts.push(failure.problem.code);
  }
  const correlation = (failure.problem as { correlation_id?: unknown }).correlation_id;
  if (typeof correlation === 'string' && correlation.length > 0) {
    parts.push(correlation);
  }
  return parts.length === 0 ? null : parts.join(' · ');
}

export function formatYekaterinburg(value: string | null | undefined): string {
  if (value === null || value === undefined || value.length === 0) {
    return '—';
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }
  return parsed.toLocaleString('ru-RU', { timeZone: YEKATERINBURG });
}

export function labeledOrRaw(value: string, labels: Record<string, string>): string {
  return labels[value] ?? value;
}

export function caseStatusLabel(status: string): string {
  return labeledOrRaw(status, CASE_STATUS_LABELS);
}

export function bookingStatusLabel(status: string): string {
  return labeledOrRaw(status, BOOKING_STATUS_LABELS);
}

export function checklistStatusLabel(status: string): string {
  return labeledOrRaw(status, CHECKLIST_STATUS_LABELS);
}

export function decisionLabel(decision: string | null | undefined): string {
  if (decision === null || decision === undefined || decision.length === 0) {
    return '—';
  }
  if (decision === 'APPROVED') {
    return 'Допущено';
  }
  if (decision === 'REJECTED') {
    return 'Не допущено';
  }
  return decision;
}

export function documentStatusLabel(status: string): string {
  return labeledOrRaw(status, DOCUMENT_STATUS_LABELS);
}

export function emailStatusLabel(status: string): string {
  return labeledOrRaw(status, EMAIL_STATUS_LABELS);
}

export function eventTypeLabel(eventType: string): string {
  return EVENT_TYPE_LABELS[eventType] ?? 'Системное событие';
}

export function userStatusLabel(status: string): string {
  return labeledOrRaw(status, USER_STATUS_LABELS);
}

export function roleLabel(code: string): string {
  return labeledOrRaw(code, ROLE_LABELS);
}

export function roleLabels(codes: readonly string[]): string {
  return codes.map(roleLabel).join(', ');
}

export function mustChangePasswordLabel(value: boolean | undefined): string {
  return value === true ? 'Требуется смена пароля' : 'Смена пароля не требуется';
}

export function masterStatusLabel(status: string): string {
  return labeledOrRaw(status, MASTER_STATUS_LABELS);
}

export function emailScopeKindLabel(kind: string): string {
  return labeledOrRaw(kind, EMAIL_SCOPE_KIND_LABELS);
}

export function emailPolicyStatusLabel(status: string): string {
  return labeledOrRaw(status, EMAIL_POLICY_STATUS_LABELS);
}

export function actorTypeLabel(actorType: string): string {
  return labeledOrRaw(actorType, ACTOR_TYPE_LABELS);
}

export function subjectTypeLabel(subjectType: string): string {
  return labeledOrRaw(subjectType, SUBJECT_TYPE_LABELS);
}

export function duplicateFieldLabel(field: string): string {
  const known = DUPLICATE_FIELD_LABELS[field];
  return known === undefined ? `Совпадение по полю ${field}` : known;
}

export function snapshotText(
  snapshot: Record<string, unknown> | null | undefined,
  keys: readonly string[],
): string | null {
  if (snapshot === null || snapshot === undefined) {
    return null;
  }
  for (const key of keys) {
    const value = snapshot[key];
    if (typeof value === 'string' && value.length > 0) {
      return value;
    }
  }
  return null;
}
